import { useCallback } from "react";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { PlanStaticRoomPriceParams_PlanManagementPage_Query } from "./query";

type Props = {
	queryVariables: {
		hotelID: string;
		roomIDs: string[];
	};
};

export const useFetchPlanStaticRoomPriceParams = ({ queryVariables }: Props) => {
	const { refetch } = useCustomSuspenseQuery(
		PlanStaticRoomPriceParams_PlanManagementPage_Query,
		{
			variables: queryVariables,
		},
		true,
	);

	const onFetchStaticRoomPrices = useCallback(
		async ({ hotelID, roomIDs }: { hotelID: string; roomIDs: string[] }) => {
			return await refetch({ hotelID, roomIDs });
		},
		[refetch],
	);

	return {
		onFetchStaticRoomPrices,
	};
};
